const devBypassStripeConnectReadiness =
  String(process.env.REACT_APP_DEV_BYPASS_STRIPE_CONNECT_READINESS || "").toLowerCase() === "true";

/** Stripe Connect / Checkout — used when REACT_APP_STRIPE_TIME_OUT is unset or invalid */
export const DEFAULT_STRIPE_REQUEST_TIMEOUT_MS = 90_000;

function parsePositiveInt(value: string | undefined, fallback: number): number {
  const n = parseInt(value ?? "", 10);
  return Number.isFinite(n) && n > 0 ? n : fallback;
}

/** Timeout for any API call under `/stripe/*` (checkout, Connect, confirm, etc.) */
export function getStripeRequestTimeoutMs(): number {
  return parsePositiveInt(process.env.REACT_APP_STRIPE_TIME_OUT, DEFAULT_STRIPE_REQUEST_TIMEOUT_MS);
}

export function isStripeApiRequestUrl(url: string | undefined): boolean {
  if (!url) return false;
  return /(^|\/)stripe\//.test(url.split("?")[0]);
}

/**
 * Same rule as backend `getReadinessForUserId` / `computeReadiness`: organiser can run paid games only when
 * Connect has charges, payouts, and onboarding details submitted (unless dev bypass is on).
 */
export function isOrganiserStripeReadyForPaidGames(user: {
  stripeAccountId?: string;
  stripeChargesEnabled?: boolean;
  stripePayoutsEnabled?: boolean;
  stripeDetailsSubmitted?: boolean;
} | undefined): boolean {
  if (!user) return false;
  if (devBypassStripeConnectReadiness) return true;
  return !!(
    user.stripeAccountId &&
    user.stripeChargesEnabled &&
    user.stripePayoutsEnabled &&
    user.stripeDetailsSubmitted
  );
}

export default {
  PUBLIC_URL: process.env.REACT_APP_PUBLIC_URL || "",
  API_URL: process.env.REACT_APP_API_URL || "",
  SOCKET_END_POINT: process.env.REACT_APP_WEBSOCKET_URL || "",
  VERSION: process.env.REACT_APP_VERSION || "",
  TIME_OUT: parseInt(process.env.REACT_APP_TIME_OUT || "5000"),
  /** Stripe Connect / Checkout — multiple round-trips to Stripe on the server; needs more than the default API timeout */
  STRIPE_TIME_OUT: getStripeRequestTimeoutMs(),
  /** Local dev only: match backend DEV_BYPASS_STRIPE_CONNECT_READINESS — unlock paid-game UI without Stripe verification */
  DEV_BYPASS_STRIPE_CONNECT_READINESS: devBypassStripeConnectReadiness,

  DATE_DISPLAY_FORMAT: "Do MMMM YYYY",
  DATE_TIME_DISPLAY_FORMAT: "Do MMMM YYYY, h:mm a",
  TIME_DISPLAY_FORMAT: "h:mm a",
  SAVE_IF_FAILED: "saveIfFailed",
  STORAGE: {
    TOKEN: "token",
    FAILED_API_CALLS: "offlineCalls",
  },
  SCORING_FORMAT: {
    STABLEFORD: "stableford",
    STROKE: "stroke",
  },
  LEADERBOARD_CONFIG: {
    ACTIVATED: {
      EVERY_ONE: 1,
      VIEW_ONLY: 2,
      ORGANIZER_ONLY: 3,
    },
    REVEAL_HIDDEN_PLACES: {
      ONE_LINE: 1,
      TWO_STEP: 2,
    },
  },
  RULES: {
    ADMIN: "admin",
    ORGANIZER: "organiser",
    PLAYER: "player",
  },
  PLAYING_FORMATS: {
    INDIVIDUAL: "individual",
    TEAM: "team",
  },
};
